import { FC } from 'react';
import classNames from 'classnames';

import { Layer } from '@hh.ru/magritte-ui';

import useFloatChatikActivatorVisible from 'src/components/FloatChatikActivator/useFloatChatikActivatorVisible';
import ResumeSearchScrollToTop from 'src/components/SearchScrollToTop/Resume';
import VacancySearchScrollToTop from 'src/components/SearchScrollToTop/Vacancy';
import SearchPreferenceButton from 'src/components/SearchSorts/SearchPreferenceButton';
import { useSearchSettings } from 'src/hooks/search/useSearchSettings';

import styles from './styles.less';

const SearchFooterButtons: FC = () => {
    const { isResumeSearchType, isVacancySearchType } = useSearchSettings();
    const floatingChatButtonVisible = useFloatChatikActivatorVisible();

    return (
        <Layer layer="alpha">
            <div
                className={classNames(styles.buttonsContainer, {
                    // tempexp_PORTFOLIO-38480_next_line
                    [styles.buttonsContainerShifted]: floatingChatButtonVisible,
                })}
            >
                {isVacancySearchType && <VacancySearchScrollToTop />}
                {isResumeSearchType && <ResumeSearchScrollToTop />}
                <SearchPreferenceButton />
            </div>
        </Layer>
    );
};

export default SearchFooterButtons;
